import { faLocationArrow } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Space, Typography } from 'antd';
import styled from 'styled-components';

const { Text } = Typography;

const FieldTitle = styled(Text)`
  width: 220px;
  text-align: left;
`;

export const RocketlaneFieldValue = ({
  label,
  boldText,
}: {
  label: string;
  boldText?: boolean;
}) => (
  <Space>
    <FontAwesomeIcon icon={faLocationArrow} color="#000000" />

    <FieldTitle strong={boldText} ellipsis={{ tooltip: true }}>
      {label}
    </FieldTitle>
  </Space>
);
